import Vue from 'vue'


function Logout(){
	return new Promise((resolve,reject)=>{
		Vue.http.get('logout').then(response=>{
			resolve(response)
		},response=>{
			reject(response)
		})
	})
}

function getGlobalVar(name){
	return new Promise((resolve,reject)=>{
		Vue.http.get('global/'+name).then(response=>{
			resolve(response.body.data)
		},response=>{
			reject(response.body.msg)
		})
	})
}


function getDataList(url){
	return new Promise((resolve,reject)=>{
		Vue.http.get(url).then(response=>{
			resolve(response.body.data.list)
		},response=>{
			reject(response.body.msg)
		})
	})
}


export default {
	Logout,
	getGlobalVar,
	getDataList
}


// WEBPACK FOOTER //
// ./src/api/common.js